
// ไฟล์: frontend/src/pages/RegisterPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import './AuthPages.css';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    fullname: '',
    email: '',
    school: '',
    subject_area: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // จัดการการเปลี่ยนแปลงข้อมูลในฟอร์ม
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // ล้างข้อความผิดพลาดเมื่อผู้ใช้แก้ไขข้อมูล
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  // ตรวจสอบข้อมูลในฟอร์ม
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.username.trim()) {
      newErrors.username = 'กรุณาระบุชื่อผู้ใช้';
    } else if (formData.username.length < 4) {
      newErrors.username = 'ชื่อผู้ใช้ต้องมีความยาวอย่างน้อย 4 ตัวอักษร';
    }
    
    if (!formData.password) {
      newErrors.password = 'กรุณาระบุรหัสผ่าน';
    } else if (formData.password.length < 6) {
      newErrors.password = 'รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร';
    }
    
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'กรุณายืนยันรหัสผ่าน';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'รหัสผ่านไม่ตรงกัน';
    }
    
    if (!formData.fullname.trim()) {
      newErrors.fullname = 'กรุณาระบุชื่อ-นามสกุล';
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'กรุณาระบุอีเมล';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'รูปแบบอีเมลไม่ถูกต้อง';
    }
    
    if (!formData.school.trim()) {
      newErrors.school = 'กรุณาระบุโรงเรียน';
    }
    
    if (!formData.subject_area.trim()) {
      newErrors.subject_area = 'กรุณาระบุกลุ่มสาระการเรียนรู้';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // จัดการการส่งฟอร์ม
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    // สร้างข้อมูลที่จะส่งไปยัง API (ไม่รวม confirmPassword)
    const { confirmPassword, ...registerData } = formData;
    
    try {
      const response = await axios.post('/auth/register', registerData);
      
      // แสดงข้อความแจ้งเตือนการสมัครสมาชิกสำเร็จ
      Swal.fire({
        icon: 'success',
        title: 'สมัครสมาชิกสำเร็จ',
        text: 'กรุณาเข้าสู่ระบบเพื่อเริ่มใช้งาน',
        timer: 2000,
        showConfirmButton: false
      });
      
      // นำทางไปยังหน้าเข้าสู่ระบบ
      navigate('/login');
    } catch (error) {
      console.error('Register error:', error);
      
      // แสดงข้อความแจ้งเตือนข้อผิดพลาด
      Swal.fire({
        icon: 'error',
        title: 'สมัครสมาชิกไม่สำเร็จ',
        text: error.response?.data?.message || 'เกิดข้อผิดพลาดในการสมัครสมาชิก กรุณาลองใหม่อีกครั้ง',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card register-card">
        <div className="auth-header">
          <h2>สมัครสมาชิก</h2>
          <p>สมัครสมาชิกเพื่อเริ่มแบ่งปันและเรียนรู้ร่วมกัน</p>
        </div>
        
        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username" className="form-label">
              <i className="fas fa-user"></i> ชื่อผู้ใช้
            </label>
            <input
              type="text"
              id="username"
              name="username"
              className={`form-control ${errors.username ? 'is-invalid' : ''}`}
              placeholder="ชื่อผู้ใช้ของคุณ"
              value={formData.username}
              onChange={handleChange}
            />
            {errors.username && <div className="invalid-feedback">{errors.username}</div>}
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password" className="form-label">
                <i className="fas fa-lock"></i> รหัสผ่าน
              </label>
              <input
                type="password"
                id="password"
                name="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                placeholder="รหัสผ่านของคุณ"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmPassword" className="form-label">
                <i className="fas fa-lock"></i> ยืนยันรหัสผ่าน
              </label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                placeholder="ยืนยันรหัสผ่านของคุณ"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
              {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword}</div>}
            </div>
          </div>
          
          <div className="form-group">
            <label htmlFor="fullname" className="form-label">
              <i className="fas fa-id-card"></i> ชื่อ-นามสกุล
            </label>
            <input
              type="text"
              id="fullname"
              name="fullname"
              className={`form-control ${errors.fullname ? 'is-invalid' : ''}`}
              placeholder="ชื่อ-นามสกุลของคุณ"
              value={formData.fullname}
              onChange={handleChange}
            />
            {errors.fullname && <div className="invalid-feedback">{errors.fullname}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              <i className="fas fa-envelope"></i> อีเมล
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              placeholder="อีเมลของคุณ"
              value={formData.email}
              onChange={handleChange}
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="school" className="form-label">
              <i className="fas fa-school"></i> โรงเรียน
            </label>
            <input
              type="text"
              id="school"
              name="school"
              className={`form-control ${errors.school ? 'is-invalid' : ''}`}
              placeholder="โรงเรียนของคุณ"
              value={formData.school}
              onChange={handleChange}
            />
            {errors.school && <div className="invalid-feedback">{errors.school}</div>}
          </div>
          
          <div className="form-group">
            <label htmlFor="subject_area" className="form-label">
              <i className="fas fa-book"></i> กลุ่มสาระการเรียนรู้
            </label>
            <input
              type="text"
              id="subject_area"
              name="subject_area"
              className={`form-control ${errors.subject_area ? 'is-invalid' : ''}`}
              placeholder="กลุ่มสาระการเรียนรู้ของคุณ"
              value={formData.subject_area}
              onChange={handleChange}
            />
            {errors.subject_area && <div className="invalid-feedback">{errors.subject_area}</div>}
          </div>
          
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> กำลังสมัครสมาชิก...
                </>
              ) : (
                <>
                  <i className="fas fa-user-plus"></i> สมัครสมาชิก
                </>
              )}
            </button>
          </div>
        </form>
        
        <div className="auth-footer">
          <p>มีบัญชีอยู่แล้ว? <Link to="/login">เข้าสู่ระบบ</Link></p>
        </div>
      </div>
      
      <div className="auth-info">
        <div className="auth-logo">
          <img src={process.env.REACT_APP_LOGO_URL || 'https://www.i-pic.info/i/krVq1004512.jpg'} alt="TeacherShare" />
          <h1>TeacherShare</h1>
        </div>
        <h2>แบ่งปัน เรียนรู้ พัฒนา ไปด้วยกัน</h2>
        <p>
          TeacherShare คือศูนย์กลางสำหรับครูในการแบ่งปันความรู้ สื่อการสอน และนวัตกรรมทางการศึกษา
          เพื่อพัฒนาการเรียนการสอนและสร้างสังคมแห่งการเรียนรู้ร่วมกัน
        </p>
        <div className="auth-features">
          <div className="auth-feature">
            <i className="fas fa-book"></i>
            <span>คลังสื่อการสอนคุณภาพ</span>
          </div>
          <div className="auth-feature">
            <i className="fas fa-lightbulb"></i>
            <span>นวัตกรรมและแนวปฏิบัติที่ดี</span>
          </div>
          <div className="auth-feature">
            <i className="fas fa-users"></i>
            <span>ชุมชนครูทั่วประเทศ</span>
          </div>
          <div className="auth-feature">
            <i className="fas fa-trophy"></i>
            <span>รางวัลและการยกย่อง</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
